import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs/Rx";
import { environment } from "../../../../environments/environment";
import { Response } from "@angular/http";

// Interfaces
import {
	IService,
	IContact,
	ILink,
	IContactModel,
	IReviewer,
	IRole
} from "../../interfaces";

// Services
import { LogService } from "../log/log.service";
import { ServerService } from "../server/server.service";
import { LoaderService } from "../loader/loader.service";
import { StorageService } from "../storage/storage.service";
import { HelperService } from "../helper/helper.service";
import { SsoService } from "../sso/sso.service";
// Helpers
// import * as helpers from '../../../helpers';

// Enums
import { RoleEnum } from "../../enums";
import { forEach } from "@angular/router/src/utils/collection";
import { I18NHtmlParser } from "@angular/compiler/src/i18n/i18n_html_parser";

@Injectable()
export class UserService implements IService {
	// implements local variables
	private _contact: BehaviorSubject<IContact> = new BehaviorSubject(
		undefined
	);
	private _contactsArray: IContact[] = [];
	private _testcontacts = new BehaviorSubject<IContact[]>(undefined);
	//Will vary after clicking application..could act as panel, board, etc based on application
	private _role: BehaviorSubject<RoleEnum> = new BehaviorSubject(
		RoleEnum.Applicant
	);
	_testAcepIds: string[];
	//Used to set wehther user is present in each role after clicking application
	IROLE: IRole;
	//does not change and drives based on role in reviewers
	public Is_QC_Reviewer: boolean;

	public CURRENTUSER_CONTACTID = undefined;
	public CURRENTUSER_ACEPID = undefined;
	public CURRENTUSER_FIRSTNAME = undefined;

	private _data: {
		contact: IContact;
		avatar: string;
	};

	// implements IService
	name = "UserService";
	test(name, value) {
		console.log("testing", name, value);
	}

	constructor(
		private _logSrv: LogService,
		private _serverSrv: ServerService,
		private _storageSrv: StorageService,
		private _helperSrv: HelperService,
		private _ssoSrv: SsoService
	) {
		this._testAcepIds = [
			"A632115",
			"A454625",
			"A417356",
			"A483303",
			"A471317",
			"A656147",
			"A680939",
			"A654724",
			"A474855"
		];
		//this._testAcepIds = ['A454625'];

		// this.getTestContacts().then(
		//   success => {
		//     this._testcontacts.next(this._contactsArray);
		//   }
		// );
		// this.getContact('A483303');
		// this.getContact('A471317');
		// this.getContact('A656147');
		// this.getContact('A680939');
	}

	get TESTCONTACTS() {
		return this._testcontacts;
	}

	get CONTACT() {
		return this._contact;
	}

	private set contact(value: IContact) {
		const data = {
			contact: undefined,
			accounts: undefined,
			account: undefined,
			model: undefined,
			avatar: undefined
		};
		this._contact.next(value);
		data.contact = value;
		if (value !== undefined) {
			this.Role = value.Role;
			this._data = data;
		} else {
			this.Role = 0;
			this._data = data;
		}
		"Setting contact in private set contact".logWithObject(this.name, {
			Data: this._data
		});
	}

	get Data() {
		return this._data;
	}

	get ROLE() {
		return this._role;
	}

	public set Role(value: RoleEnum) {
		if (this.Data && this.Data.contact) {
			this.Data.contact.Role = value;
		}
		this._role.next(value);
	}

	getContactFromCRM(acepid: string): Promise<IContact> {
		this._logSrv.Debug(this.name, ["getContact", acepid]);
		return this.getTestContact(acepid)
			.map(response => {
				const body = response.json();
				const contact = <IContactModel>body.Data;

				return contact.Contact;
			})
			.toPromise();
	}

	getTestContacts(): Promise<IContact[]> {
		return new Promise((resolve, fail) => {
			try {
				const tstCntcts = this._storageSrv.getSession<IContact[]>(
					this._storageSrv.TEST_CONTACTS
				);
				if (tstCntcts !== undefined) {
					this._logSrv.Debug(this.name, [
						"getTestContacts from storage",
						tstCntcts
					]);
					resolve(tstCntcts);
				} else {
					const promises: Promise<Response>[] = [];
					this._testAcepIds.forEach(acepid => {
						promises.push(this.getTestContact(acepid).toPromise());
					});
					Promise.all(promises).then(
						response => {
							response.forEach(contact => {
								this.addToTestList(contact);
							});
							this._storageSrv.setSession(
								this._storageSrv.TEST_CONTACTS,
								this._contactsArray
							);
							this._logSrv.Debug(this.name, [
								"getTestContacts",
								this._contactsArray
							]);
							resolve(this._contactsArray);
						},
						failResponse => {
							fail(failResponse);
						}
					);
				}
			} catch (err) {
				fail(err);
			}
		});
	}

	getTestContact(acepid: string): Observable<Response> {
		this._logSrv.Debug(this.name, ["getTestContact", acepid]);
		return this._serverSrv.GetWithAuth(
			acepid,
			`${environment.APILocation}contact/${acepid}`
		);
	}

	addTestContact(acepid: string): Promise<IContact> {
		this._logSrv.Debug(this.name, ["addTestContact", acepid]);
		return new Promise((resolve, fail) => {
			this.getTestContact(acepid)
				.toPromise()
				.then(
					response => {
						const contact = this.addToTestList(response);
						resolve(contact);
					},
					failResponse => {
						fail(failResponse);
					}
				);
		});
	}
	addToTestList(response: Response): IContact {
		this._logSrv.Debug(this.name, [
			"addToTestList",
			{ response: response }
		]);
		const body = response.json();
		this._logSrv.Debug(this.name, [
			"addToTestList",
			{ body: body, data: body.Data }
		]);
		const contact = <IContactModel>body.Data;
		this._contactsArray.push(contact.Contact);
		return contact.Contact;
	}

	getContact() {
		const exist = this._data && this._data.contact;

		//console.log('set the contact in getcontact');
		if (!exist) {
			console.log(
				"getcontact does not have a contact. create one from session"
			);
			const strg = this._storageSrv.getSession<IContact>(
				this._storageSrv.CONTACT
			);
			"getContact filled in".logWithObject(this.name, strg);
			this.contact = strg;
		}
		return this._data && this._data.contact
			? this._data.contact
			: undefined;
	}

	setContact(caller: string, value: IContact, avatar: string = "") {
		"Setting contact in setContact function".logWithObject(this.name, [
			caller,
			value,
			avatar
		]);
		this._storageSrv.setSession(this._storageSrv.CONTACT, value);
		this.contact = value;
		this._data.avatar = this._ssoSrv.DATA.avatar || avatar;

		this.CURRENTUSER_CONTACTID = value ? value.Id : undefined;
		this.CURRENTUSER_ACEPID = value ? value.AcepId : undefined;
		this.CURRENTUSER_FIRSTNAME = value
			? value.Profile.FirstName
			: undefined;
	}

	signOut(caller: string) {
		this._logSrv.Debug(this.name, ["signOut before", this.Data]);
		this.setContact(caller, undefined);
		this.Is_QC_Reviewer = undefined;
		if (this._helperSrv.env === "development") {
			this._helperSrv.goToLogin();
		} else {
			this._ssoSrv.logout();
		}

		this._logSrv.Debug(this.name, ["signOut after", this.Data]);
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/user/user.service.ts